import { Component, effect, inject, untracked } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { MessageService, PrimeTemplate } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { ToastCloseEvent } from 'primeng/types/toast';
import { UiActions } from '../../../core/state/ui/ui.actions';
import { selectToast } from '../../../core/state/ui/ui.selectors';

@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [Toast, PrimeTemplate],
  providers: [MessageService],
  templateUrl: './toast-host.html',
  styleUrl: './toast-host.css',
})
export class ToastHost {
  private readonly store = inject(Store);
  private readonly messages = inject(MessageService);
  private readonly toast = toSignal(this.store.select(selectToast), { initialValue: null });

  constructor() {
    effect(() => {
      const toast = this.toast();
      untracked(() => {
        this.messages.clear();
        if (!toast) {
          return;
        }
        this.messages.add({
          id: toast.id,
          severity: toast.severity,
          summary: toast.summary,
          detail: toast.detail,
          life: toast.severity === 'error' ? 6000 : 4000,
        });
      });
    });
  }

  onPrimeToastClose(event: ToastCloseEvent): void {
    const current = this.toast();
    if (!current || event.message?.id == null) {
      return;
    }
    if (String(event.message.id) !== String(current.id)) {
      return;
    }
    this.store.dispatch(UiActions.clearToast());
  }
}
